import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { useCreateHostMutation } from '../../api/peopleApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import buttons from '../../styles/shared/buttons.module.css';

export default function HostCreatePage() {
  const navigate = useNavigate();
  const showToast = useToast();

  const [createHost, { isLoading: isCreating }] = useCreateHostMutation();

  const { control, handleSubmit } = useForm({
    defaultValues: { name: '', email: '', password: '' },
  });

  const onCreate = async (data) => {
    try {
      await createHost({
        name: data.name.trim(),
        email: data.email.trim().toLowerCase(),
        password: data.password,
      }).unwrap();
      showToast('success', 'Hosts', 'Host added.');
      navigate('/manager/hosts');
    } catch (err) {
      showToast(
        'error',
        'Hosts',
        err?.status === 409 ? 'A host with that email already exists.' : errMsg(err, 'Could not create host.'),
      );
    }
  };

  return (
    <EntityFormPage title="Add host" backTo="/manager/hosts">
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Name</label>
              <InputText id={field.name} className="w-full mb-3" {...field} />
            </div>
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Email</label>
              <InputText id={field.name} type="email" className="w-full mb-3" {...field} />
            </div>
          )}
        />
        <Controller
          name="password"
          control={control}
          rules={{ required: true, minLength: 8 }}
          render={({ field, fieldState }) => (
            <div className="field">
              <label htmlFor={field.name}>Password (min 8 chars)</label>
              <Password
                inputId={field.name}
                className={`w-full ${fieldState.invalid ? 'p-invalid' : ''}`}
                inputClassName="w-full"
                toggleMask
                feedback={false}
                {...field}
              />
            </div>
          )}
        />
        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isCreating} />
      </form>
    </EntityFormPage>
  );
}
